var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preliminary"},[_c('approval',{attrs:{"departmentId":_vm.departmentId,"isBillType":_vm.isBillType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }